module.exports = __webpack_public_path__ + "69190b89406f505e6d0eb43f3daeda47.png";